
export enum EsApplicantIdentityType {
  ID = 'ID',
  Passport = 'Passport'
}
